import { AddLinkIcon } from '@shared/assets';
import { IconButton } from '@shared/ui/buttons';
import { useNoteTools } from '../../model/hooks';
import st from './styles.module.scss';

export const AddLinkButton: React.FC = () => {
  const { setVisibleTools, switchOpenTools, setUrlModalOpen } = useNoteTools();

  const handleClick = () => {
    switchOpenTools();
    setVisibleTools(false);
    setUrlModalOpen(true);
  };

  return (
    <>
      <IconButton variant="white" type="button" className={st.addBtn} onClick={handleClick}>
        <AddLinkIcon />
      </IconButton>
    </>
  );
};
